import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "height", "color"];
var __jsx = React.createElement;
import React from "react";
const CarDoorIcon = _ref => {
  let {
      size = "14",
      height = "17",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({}, attributes, {
    width: size,
    height: height,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6007 0.123047C12.2614 0.123047 12.8553 0.603522 13.1505 1.3766C13.2701 1.68983 13.3333 2.04065 13.3333 2.3908V14.6685C13.3333 15.4707 12.8349 16.123 12.222 16.123H2.80506C2.17454 16.123 1.58199 15.8017 1.13623 15.2182C0.769697 14.7385 0.530947 14.1039 0.464489 13.4313L1.07465e-05 8.7381C-0.00215071 7.53214 0.321807 6.41672 0.91027 5.55061L3.51865 1.7097C4.20344 0.701159 5.18722 0.123047 6.21792 0.123047H11.6007ZM11.6034 1.57826C11.8405 1.57826 12.0534 1.75048 12.159 2.02781C12.2018 2.14004 12.2246 2.26573 12.2246 2.39146V8.4873C12.2246 8.6883 12.1004 8.85094 11.9468 8.85094H1.3913C1.23776 8.85094 1.11352 8.6883 1.11352 8.4873C1.11352 7.57397 1.41709 7.0008 1.74477 6.5175L4.35302 2.67663C4.82718 1.97848 5.50835 1.57826 6.2215 1.57826H11.6034ZM11.9437 10.3013H10.277C10.1235 10.3013 9.99923 10.4639 9.99923 10.6649C9.99923 10.8659 10.1235 11.0286 10.277 11.0286H11.9437C12.0972 11.0286 12.2215 10.8659 12.2215 10.6649C12.2214 10.4639 12.0972 10.3013 11.9437 10.3013ZM1.9442 12.4846H11.9442C12.0977 12.4846 12.222 12.6473 12.222 12.8483C12.222 13.0493 12.0977 13.2119 11.9442 13.2119H1.9442C1.79066 13.2119 1.66641 13.0493 1.66641 12.8483C1.66641 12.6473 1.79066 12.4846 1.9442 12.4846Z",
    fill: color
  }));
};
export default CarDoorIcon;